import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";
import DocumentInfoChart from "../chart/DocumentInfoChart";
import DisplayLocation from "../taxonomy/discussions/DisplayLocation";
import DisplayDocumentType from "../DisplayDocumentType";
import DocumentCategories from "../document/DocumentCategories";
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  CardHeader,
  CardContent,
  IconButton,
  makeStyles,
  Badge,
  Tooltip,
  Typography,
} from "@material-ui/core";
import moment from "moment";
import DisplayUser from "../user/DisplayUser";

const useStyles = makeStyles((theme) => ({
  cardContent: {
    padding: 0,
  },
}));
function SidebarInfo(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <>
      {props.show && (
        <>
          <CardHeader
            titleTypographyProps={{ component: "h3" }}
            title={t("document_info_header")}
            action={
              <IconButton
                onClick={props.toggleSidebar}
                aria-label={"Close sidebar"}
              >
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent className={classes.cardContent}>
            <DocumentInfoChart
              width={270}
              height={150}
              document={props.documentData}
            />
            <div className={classes.infoTable}>
              <Table size="small">
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {t("global_topic")}
                    </TableCell>
                    <TableCell>
                      <DisplayLocation
                        type="TOPIC"
                        itemId={props.documentData.communityId}
                        topicId={props.documentData.communityId}
                        title={props.documentData.topicName}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {t("document_type")}
                    </TableCell>
                    <TableCell>
                      <DisplayDocumentType
                        documentTypeId={props.documentData.documentTypeId}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {t("global_category_plural")}
                    </TableCell>
                    <TableCell>
                      <DocumentCategories
                        defaultValue={props.documentData.documentCategories}
                        chipsOnly
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("global_author")}</TableCell>
                    {props.documentData.author ? (
                      <TableCell>
                        <DisplayUser
                          userId={
                            props.documentData.author ? props.documentData.author.userId : ""
                          }
                          user={props.documentData.author}
                        />
                      </TableCell>
                    ) : (
                      <TableCell>{t("global_not_applicable")}</TableCell>
                    )}
                  </TableRow>
                  {/* <TableRow>
                    <TableCell>{t("global_author")}</TableCell>
                    <TableCell>
                      <DisplayUser
                        userId={props.documentData.author.userId}
                        user={props.documentData.author}
                      />
                    </TableCell>
                  </TableRow> */}
                  <TableRow>
                    <TableCell>
                      {t("settings_document_last_date_modified")}
                    </TableCell>
                    <TableCell>
                      {moment(props.documentData.dateModified).format("lll")}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      {t("settings_document_number_of_liked")}
                    </TableCell>
                    <TableCell>
                      {props.documentData.likedCount}
                      {props.documentData.likedCount > 0 &&
                        props.documentData.likedRanking > 0 && (
                          <span style={{ marginLeft: "10px" }}>
                            <Tooltip
                              title={
                                <Typography>
                                  {" "}
                                  {t("global_ranked") +
                                    " " +
                                    props.documentData.likedRanking +
                                    " " +
                                    t("global_most_liked")}
                                </Typography>
                              }
                            >
                              <Badge>
                                <span
                                  style={{
                                    fontSize: "1.4em",
                                    marginRight: "3px",
                                  }}
                                  class="mdi mdi-trophy-outline"
                                />
                                {props.documentData.likedRanking}
                              </Badge>
                            </Tooltip>
                          </span>
                        )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      {t("settings_document_number_of_times_favourited")}
                    </TableCell>
                    <TableCell>
                      {props.documentData.favouritedCount}
                      {props.documentData.favouritedCount > 0 &&
                        props.documentData.favouriteRanking > 0 && (
                          <span style={{ marginLeft: "10px" }}>
                            <Tooltip
                              title={
                                <Typography>
                                  {t("global_ranked") +
                                    " " +
                                    props.documentData.favouriteRanking +
                                    " " +
                                    t("global_most_favourited")}
                                </Typography>
                              }
                            >
                              <Badge>
                                <span
                                  style={{
                                    fontSize: "1.4em",
                                    marginRight: "3px",
                                  }}
                                  class="mdi mdi-trophy-outline"
                                />
                                {props.documentData.favouriteRanking}
                              </Badge>
                            </Tooltip>
                          </span>
                        )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      {t("settings_document_number_of_times_viewed")}
                    </TableCell>
                    <TableCell>
                      {props.documentData.viewedCount}
                      {props.documentData.viewedCount > 0 &&
                        props.documentData.viewedRanking > 0 && (
                          <span style={{ marginLeft: "10px" }}>
                            <Tooltip
                              title={
                                <Typography>
                                  {t("global_ranked") +
                                    " " +
                                    props.documentData.viewedRanking +
                                    " " +
                                    t("global_most_viewed")}
                                </Typography>
                              }
                            >
                              <Badge>
                                <span
                                  style={{
                                    fontSize: "1.4em",
                                    marginRight: "3px",
                                  }}
                                  class="mdi mdi-trophy-outline"
                                />
                                {props.documentData.viewedRanking}
                              </Badge>
                            </Tooltip>
                          </span>
                        )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      {t("settings_document_number_of_times_used")}
                    </TableCell>
                    <TableCell>
                      {props.documentData.usedCount}
                      {props.documentData.usedCount > 0 &&
                        props.documentData.usageRanking > 0 && (
                          <span style={{ marginLeft: "10px" }}>
                            <Tooltip
                              title={
                                <Typography>
                                  {t("global_ranked") +
                                    " " +
                                    props.documentData.usageRanking +
                                    " " +
                                    t("global_most_used")}
                                </Typography>
                              }
                            >
                              <Badge>
                                <span
                                  style={{
                                    fontSize: "1.4em",
                                    marginRight: "3px",
                                  }}
                                  class="mdi mdi-trophy-outline"
                                />
                                {props.documentData.usageRanking}
                              </Badge>
                            </Tooltip>
                          </span>
                        )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      {t("settings_document_date_last_viewed_by_me")}
                    </TableCell>
                    <TableCell>
                      {!!props.documentData.myLastViewed
                        ? moment(props.documentData.myLastViewed).format("lll")
                        : "n/a"}
                    </TableCell>
                  </TableRow>
                  {props.documentData.knowledgeItem === true && (
                    <>
                      <TableRow>
                        <TableCell>
                          {t("settings_document_user_who_last_modified")}
                        </TableCell>
                        <TableCell>
                          {props.documentData.lastModifiedByUserString}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          {t("settings_document_rework_count")}
                        </TableCell>
                        <TableCell>{props.documentData.reworkCount}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>{t("settings_document_author")}</TableCell>
                        <TableCell>{props.documentData.author}</TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </>
      )}
    </>
  );
}

export default SidebarInfo;
